var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewer',{attrs:{"article":_vm.article}},[_c('el-breadcrumb',{attrs:{"slot":"header"},slot:"header"},[_c('el-breadcrumb-item',{attrs:{"to":{name: 'news'}}},[_vm._v("News")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.article.header))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc57d99","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/Sent.vue
// module id = null
// module chunks = 